import { Component,OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, Form } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
declare var $: any;
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent {
  // exturl:string = null;
  exturl: string = '';
  searchForm:FormGroup;
  keyword = 'keyword';
  data = [];
  inputSearch = '';
  pagename:string='Bcl Home page Menu';
  constructor(private frmbuilder:FormBuilder,private searchservice:DataService, private router:Router) {
    this.searchForm = frmbuilder.group({
      s:['',[Validators.required,Validators.minLength(2)]]
    });
  }
  ngOnInit(): void {
    $(document).ready(function() {
      $('.material-icons').css('display', 'none');
      $('header .sidebar-menu .menu-content .search_section .searchbox').css('padding', '0px 0px 0px 0px');
    });
  }
  selectEvent(item:any) {
    this.inputSearch = item.keyword;
    this.exturl = item.link;
    this.onSubmit();
  }
  onSubmit(){
    if(this.exturl!==null){
      // this.registerGAMenuSearch(this.inputSearch);
      this.searchForm.reset();
        window.location.href = this.exturl;
    }else{
      // this.registerGAMenuSearch(`Not Found: ${this.inputSearch}`);
    }
  }
  openSuggestionBox(val:string){
   }
  onChangeSearch(val: string) {
    this.inputSearch = val;
    let res:any;
    $(document).ready(function() {
        $('.suggestions-container').css('display', 'block');
    });
    this.searchservice.search(val).subscribe((response:any)=>{
      this.data = response["data"];
      $(document).ready(function() {
        $('.material-icons').css('display', 'none');
          // $('.material-icons').css('margin-right', '25px');
      });
     });
  }
  onFocused(e:any){
  }
  onInputCleared(e:any){
   this.exturl = '';
   $(document).ready(function() {
      $('.suggestions-container').css('display', 'none');
  });
  }
  onPanelOpen(e:any){
  }
  // registerGAMenuSearch(menu){
  //   if(menu === "not-found"){
  //     this.ga.services_search_click({
  //       label: `Not Found: ${this.inputSearch}`,
  //       pagetype: window.location.href.split("/").pop() || 'home'
  //     });
  //   }
  //   else{
  //     this.ga.menu_search_click({
  //       label: menu,
  //       pagetype: window.location.href.split("/").pop() || 'home'
  //     });
  //   }
  // }
}